import { createContext, useContext } from 'react';

export const StorePickerContext = createContext(null);

export const useStorePickerContext = () => useContext(StorePickerContext);
